import styled from 'styled-components';

import {commonPalette} from 'styles/palette';

import {transparentize} from 'utils/color-utils';

export const getContentStyles = ({isDesktop}) => ({
  border: 0,
  borderRadius: 4,
  bottom: 'auto',
  boxShadow: [
    '0 24px 38px rgba(0, 0, 0, 0.14)',
    '0 9px 46px rgba(0, 0, 0, 0.12)',
    '0 11px 15px rgba(0, 0, 0, 0.2)'
  ].join(),
  display: 'flex',
  flexDirection: 'column',
  left: '50%',
  minHeight: isDesktop ? 164 : 172,
  padding: 24,
  position: 'fixed',
  right: 'auto',
  top: '50%',
  transform: 'translate(-50%, -50%)',
  width: isDesktop ? 500 : 350
});

export const getOverlayStyles = () => ({
  backgroundColor: transparentize(commonPalette.txGrey, 0.3)
});

export const Button = styled.div`
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
  letter-spacing: 1.25px;
  line-height: 40px;
  margin-left: 10px;
  padding: 0 12px;
  text-transform: uppercase;
  white-space: nowrap;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }
`;

export const WrapperButton = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`;

export const Title = styled.div`
  font-size: 22px;
  line-height: 20px;
  margin: 0 0 19px;
`;

export const Subtitle = styled.div`
  color: rgba(0, 0, 0, 0.6);
  font-size: 14px;
  line-height: 20px;
  margin: 0 0 24px;
`;
